import { COLOR_PALETTE } from "colors"
import {
	InternalDate,
	MOBILE_YEAR_PRESET,
	MONTH_PRESET,
	QUARTER_PRESET,
	RangeCalendar,
	YEAR_PRESET,
	CURRENT_QUARTER_VS_LAST_YEAR_PRESET,
	MOBILE_QUARTER_VS_LAST_YEAR_PRESET,
	MONTH_DATE_VS_LAST_YEAR_PRESET,
	MOBILE_MONTH_VS_LAST_YEAR_PRESET,
} from "components/Shared/MultiRangeCalendar"

export const DAYS_WITH_DELAY = 3
export const WEEKS_DATA_SAVED = 110

export const EMPTY_DATE_RANGE: [InternalDate, InternalDate] = [null, null]

export const DATE_FORMAT_BENCHMARK_CALENDAR = "dd/MM/yyyy"
export const MONTHS_TO_SHOW = 2

export enum PhronesisRanges {
	Current = 0,
	Previous = 1,
	Unkown = -1,
}

export const PHRONESIS_PRESETS = [
	YEAR_PRESET,
	MOBILE_YEAR_PRESET,
	QUARTER_PRESET,
	CURRENT_QUARTER_VS_LAST_YEAR_PRESET,
	MOBILE_QUARTER_VS_LAST_YEAR_PRESET,
	MONTH_PRESET,
	MONTH_DATE_VS_LAST_YEAR_PRESET,
	MOBILE_MONTH_VS_LAST_YEAR_PRESET,
]

export const INTIAL_RANGES: RangeCalendar[] = [
	{
		id: "currentDate",
		startDate: new Date(),
		endDate: new Date(),
		color: COLOR_PALETTE.DARK_PURPLE_600,
		secondaryColor: COLOR_PALETTE.PURPLE_100,
		label:
			"phronesis.transactional.application.commercial.benchmark.current.date",
	},
	{
		id: "previousDate",
		startDate: new Date(),
		endDate: new Date(),
		color: COLOR_PALETTE.YELLOW_500,
		secondaryColor: COLOR_PALETTE.YELLOW_100,
		label:
			"phronesis.transactional.application.commercial.benchmark.previous.date",
	},
]
